import { render, staticRenderFns } from "./EpsonFiscalReceipt.vue?vue&type=template&id=120813f8&scoped=true&"
import script from "./EpsonFiscalReceipt.vue?vue&type=script&lang=js&"
export * from "./EpsonFiscalReceipt.vue?vue&type=script&lang=js&"
import style0 from "./EpsonFiscalReceipt.vue?vue&type=style&index=0&id=120813f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120813f8",
  null
  
)

export default component.exports